import { Component, EventEmitter, Input, OnInit, Output, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from '../page-header/page-header.component';
import { CommonFunctions } from '@app/shared/util/common-functions';
import { Router, RouterModule } from '@angular/router';
import { AddIntlApplicationNotesComponent } from '@pages/intake/add-intl-application-notes/add-intl-application-notes.component';
import { SharedModule } from '@app/shared/shared.module';
import { NoDataConstants } from '@app/shared/constants/no-data-constants';

@Component({
  selector: 'app-no-data-available',
  imports: [CommonModule, PageHeaderComponent, RouterModule, SharedModule],
  templateUrl: './no-data-available.component.html',
  styleUrl: './no-data-available.component.css'
})
export class NoDataAvailableComponent implements OnInit {
  @Input() pageType: string = '';
  @Input() pageDetails: any;
  @Input() accessType: string = '';
  @Output() openAddPage = new EventEmitter<any>();
  commonFn = inject(CommonFunctions);
  noDataConstants: any = inject(NoDataConstants);
  router: any = inject(Router);
  pageData$ = signal<any>({});
  showPageHeader$ = signal<boolean>(true);
  backButtonUrl$ = signal<string>('');
  addCss: boolean = false;
  addmtCss: boolean = false;

  ngOnInit(): void {
    this.getPageDetails();
  }

  getPageDetails() {
    this.addmtCss = this.pageType.includes('availability');
    const currentPage: any = ['related_course', 'related_institution', 'availability', 'tests_er', 'qualification_er']?.find((page: any) => this.pageType.includes(page)) || '';
    this.addCss = !currentPage;
    if (['add-intl-notes', 'non-edu-org', 'forward-generate'].includes(this.pageType)) {
      this.pageData$.set(this.noDataConstants[this.pageType]);
      if (this.pageType === 'add-intl-notes')
        this.backButtonUrl$.set('/manage-intake');
    }
    this.showPageHeader$.set(!currentPage);
    if (currentPage in this.noDataConstants)
      this.pageData$.set(this.noDataConstants[currentPage]);
  }

  addNewData() {
    if (this.pageType === 'add-intl-notes')
      this.commonFn.openDialog(AddIntlApplicationNotesComponent, this.pageType, this.pageDetails, 'manage-intake');
    else if (!this.pageType.includes('view_related_course'))
      this.openAddPage.emit({ pageType: 'add' });
  }
}
